import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';

import { DatePipe } from '@angular/common';

import { IFRDedicats } from '../../notes/dedicats.interfaces';
import { DedicatsService } from '../../notes/dedicats.service';
import * as moment from 'moment';

export interface DedicatsElement {
  codi: string;
  hores: number;
}

const ELEMENT_DATA: DedicatsElement[] = [
  {codi: '', hores: 0},
];

@Component({
  selector: 'dialog-dedicats',
  templateUrl: './dialog.component.dedicats.html',
  styleUrls: ['./dialog.component.dedicats.scss'],
  providers: [ DedicatsService, DatePipe ]
})

export class DialogDedicats implements OnInit {
   public showAsyncProgress: boolean = false;
   public dedicacionsData: Array<IFRDedicats> = [];
   public llistaCodis: any;
   public tbCodis: any;
   public tipus: number = 0;
   public hores_periode: number = 0;
   public codi: string = '';
   private op: any = 'NEW';
   public esProjecte: boolean = false;
   public esProposta: boolean = false;
   public esPreproposta: boolean = false;
   public horesProjHidden: boolean = true;

   public userInfo: any = {};

   public editDedicacionsData = Object.assign({});
   //IFRDedicacio;
   private DedicacionsModel: IFRDedicats = {
      'id': 'NEW',
      'personal_id': null,
      'descripcio': null,
      'hores': null,
      'inici': null,
      'fi': null,
      'percent': null,
      'codi': null,
      'tipus': null
   };

   public displayedColumns: string[] = ['codi', 'hores'];
   public dataSource = ELEMENT_DATA;

  public filterStates(val: string) {
    if(!this.tbCodis)this.tbCodis = this.llistaCodis;
    if(val)return this.llistaCodis.filter( item => item.codi.toLowerCase().includes(val.toLowerCase()) );
    return this.llistaCodis;
  }

  public requestRowsToParent(): void {
    this.dedicatsService.get(
       this.userInfo.id, this.codi, this.tipus
    ).subscribe(
       data => { this.dedicacionsData = data; },
       error => console.log(error)
    );
  }

  public chngTipus(id){ 
     this.tipus= id;
     this.esProjecte = (id == 0);
     this.esProposta = (id == 1)
     this.esPreproposta = (id == 2)
     //this.requestRowsToParent();
  }

  public esborrar(id, fila): void { this.dedicatsService.delete(id).subscribe(codis => {
     this.dedicacionsData.splice(fila,1);
    });
  }

  public editar(i): void { this.editDedicacionsData = this.dedicacionsData[i]; this.op = this.editDedicacionsData.id;}

  constructor(public translate: TranslateService, public languageService: LanguageService, private tokenStorage: TokenStorageService, private dedicatsService: DedicatsService, public dialogRef: MatDialogRef<DialogDedicats>, @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.userInfo = this.tokenStorage.getUser();
    this.editDedicacionsData = data;
    this.editDedicacionsData.personal_id = this.userInfo.id;

    if(!this.editDedicacionsData.inici)this.editDedicacionsData.inici = moment().format("YYYY-MM-DD");
    if(!this.editDedicacionsData.fi)this.editDedicacionsData.fi = moment().format("YYYY-MM-DD");
    this.cnvDts();
  }

  private workday_count(start,end) {
    var first = start.clone().endOf('week'); // end of first week
    var last = end.clone().startOf('week'); // start of last week
    var days = last.diff(first,'days') * 5 / 7; // this will always multiply of 7
    var wfirst = first.day() - start.day(); // check first week
    if(start.day() == 0) --wfirst; // -1 if start with sunday 
    var wlast = end.day() - last.day(); // check last week
    if(end.day() == 6) --wlast; // -1 if end with saturday
    return wfirst + Math.floor(days) + wlast; // get the total
  }

  cnvDts(){this.editDedicacionsData.percent = null;
    if(this.editDedicacionsData.inici && this.editDedicacionsData.fi)this.editDedicacionsData.percent = 100;
    var wd = this.workday_count(moment(this.editDedicacionsData.inici),moment(this.editDedicacionsData.fi));
    //this.editDedicacionsData.hores = (moment(this.editDedicacionsData.fi).diff(moment(this.editDedicacionsData.inici), "days") + 1) * 8;
    this.editDedicacionsData.hores = Math.abs(wd) * 8;
    this.dedicatsService.getHoresFetes(
       this.userInfo.id, this.editDedicacionsData.codi, this.tipus, this.editDedicacionsData.inici, this.editDedicacionsData.fi
    ).subscribe(
       data => {this.hores_periode = data['sum']; this.editDedicacionsData.hores -= this.hores_periode;},
       error => console.log(error)
    );
  }

  cnvHores(){
    if(!this.editDedicacionsData.fi || !this.editDedicacionsData.inici || !this.editDedicacionsData.hores)return;
    if(this.editDedicacionsData.hores == 0 || !this.editDedicacionsData.hores)return;
    //this.editDedicacionsData.percent = 100 * this.editDedicacionsData.hores / ((moment(this.editDedicacionsData.fi).diff(moment(this.editDedicacionsData.inici), "days") +1) * 8);
    var wd = this.workday_count(moment(this.editDedicacionsData.inici),moment(this.editDedicacionsData.fi));
    this.editDedicacionsData.percent = this.editDedicacionsData.hores / (wd * 8) * 100;
  }

  llistarHoresProj(){
  this.dedicatsService.getHoresProj(this.userInfo.id, this.tipus, this.editDedicacionsData.inici, this.editDedicacionsData.fi)
    .subscribe(
       codis => { this.dataSource = codis; this.horesProjHidden = !this.horesProjHidden; },
       error => console.log(error)
    );
  }

  ngOnInit() {
    this.dedicatsService.getCodis(this.userInfo.id, this.tipus)
    .subscribe(
       codis => { 
         this.tbCodis = codis; this.llistaCodis = codis;
         if(!this.editDedicacionsData.inici)this.editDedicacionsData.inici = moment().format("YYYY-MM-DD");
         if(!this.editDedicacionsData.fi)this.editDedicacionsData.fi = moment().format("YYYY-MM-DD");
         if(!this.editDedicacionsData.codi)return;
         this.codi = this.editDedicacionsData.codi;
         this.tipus = this.editDedicacionsData.tipus;
         this.esProjecte = (this.tipus == 0);
         this.esProposta = (this.tipus == 1)
         this.esPreproposta = (this.tipus == 2)
         this.dedicatsService.get(this.userInfo.id, this.codi, this.tipus)
         .subscribe(
           data => {         
             if(!this.editDedicacionsData.inici)this.editDedicacionsData.inici = moment().format("YYYY-MM-DD");
             if(!this.editDedicacionsData.fi)this.editDedicacionsData.fi = moment().format("YYYY-MM-DD");
             this.dedicacionsData = data },
           error => console.log(error)
          );
       },
       error => console.log(error)
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    //this.dialogRef.close(this.editDedicacionsData);
    if(!this.editDedicacionsData.hores){alert(this.translate.instant('dedicacionsDialog.avisHoresBlanc'));return;};
    if(moment(this.editDedicacionsData.inici, 'YYYY/MM/DD').format("YYYY") > 
       moment(this.editDedicacionsData.fi, 'YYYY/MM/DD').format("YYYY")){
           alert(this.translate.instant('dedicacionsDialog.avisDataIniciFinal'));return;
    }
    if(moment(this.editDedicacionsData.inici, 'YYYY/MM/DD').format("YYYY") != 
       moment(this.editDedicacionsData.fi, 'YYYY/MM/DD').format("YYYY")){
           alert(this.translate.instant('dedicacionsDialog.avisMateixAny'));return;
    }
    if(moment(this.editDedicacionsData.inici, 'YYYY/MM/DD').format("M") != 
       moment(this.editDedicacionsData.fi, 'YYYY/MM/DD').format("M")){
           alert(this.translate.instant('dedicacionsDialog.avisMateixMes'));return;
    }
    this.showAsyncProgress = true;
    this.dedicatsService.update(this.op, this.editDedicacionsData)
      .subscribe(updatedData => {
        this.editDedicacionsData = updatedData;
        if(this.op == 'NEW')this.dedicacionsData.unshift(Object.assign(this.editDedicacionsData));
        this.op = 'NEW';
        console.log(this.editDedicacionsData)
        let di,df
        di = this.editDedicacionsData.inici;
        df = this.editDedicacionsData.fi;

        this.editDedicacionsData = Object.assign({})
        this.editDedicacionsData.id= 'NEW';
        this.editDedicacionsData.personal_id = updatedData.personal_id;
        this.editDedicacionsData.codi = updatedData.codi;
        this.editDedicacionsData.hores = 8;
        this.editDedicacionsData.percent = 100;
        this.editDedicacionsData.descripcio = '';
        //Canvi 271025
        //this.editDedicacionsData.inici = moment().format("YYYY-MM-DD");
        //this.editDedicacionsData.fi = moment().format("YYYY-MM-DD");
        this.editDedicacionsData.inici = di;
        this.editDedicacionsData.fi = df;
        //fi canvi 271025
        this.editDedicacionsData.tipus = updatedData.tipus;
        this.cnvDts()
        this.showAsyncProgress = false;
      });
  }

  close(): void {
    this.dialogRef.close(null);
  }

}
